var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"news-main"},[_c('SiteTop'),_c('div',{staticClass:"news-center"},[_c('LeftNav')],1),_c('SiteFoot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }